import { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import './moduleChoice.css'

export function RemoteEntryPage() {
  const [accepted, setAccepted] = useState(false)
  const { access } = useAuth()
  if (access.companyAccount) return <Navigate to="/modulos" replace />
  return <main className="module-choice"><section className="module-choice-inner">
    <img src="/logo.png" alt="" className="module-choice-logo" />
    <h1>Spectra Remote</h1>
    <p>O acesso ao módulo não habilita o controle deste aparelho. Cada conexão precisa da autorização de quem a recebe.</p>
    <p>No computador, use o aplicativo Spectra Remote. Entre com seu usuário ou e-mail do Spectra.</p>
    <label><input type="checkbox" checked={accepted} onChange={event => setAccepted(event.target.checked)} /> Quero usar o Remote neste computador.</label>
    {accepted && <p><a className="module-choice-logout" href="/remote/SpectraRemote-Windows-x64-Setup.exe" download>Baixar Spectra Remote para Windows</a></p>}
    <p><Link className="module-choice-logout" to="/modulos">Voltar aos módulos</Link></p>
  </section></main>
}
